import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
// import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { MdArrowBackIosNew } from "react-icons/md";
import HeroImg from "../../Shared components/HeroImg";
import { LoginUser } from "../../types/user";
import axios from "axios";
import { Config } from "../../API/config";
import BeatLoader from './../../../node_modules/react-spinners/esm/BeatLoader';
import { useCookies } from 'react-cookie';
interface LoginFormValues {

  email: string;
  password: string;
  role: string;
}

export default function LoginPage() {
  const [cookies, setCookie, removeCookie] = useCookies(['user-data', "token"]);
  const [viewPassword, setViewPassword] = useState(false);

  const handleViewPass = () => {
    setViewPassword(!viewPassword);
  };
  const navigate = useNavigate()
  const validationSchema = Yup.object({
    email: Yup.string()
      .required("Email is reuired"),
    password: Yup.string()
      .required("password is reuired"),
  });
  const [isLoading, setLoading] = useState(false);

  async function sendData(values: LoginUser) {
    try {
      setLoading(true);
      const { data } = await axios.post(Config.login, values, {
        withCredentials: true,
      });

      if (data.statusCode === 200) {
        setCookie("user-data", data.data.user);
        setCookie("token", data.data.accessToken);
        if (data.data.user.role === "admin") {
          navigate("/admins");
        } else if (data.data.user.role === "trainee") {
          if (data.data.user.block == true) {
            toast.error("تم حظرك من قبل الادمن");
            removeCookie("user-data");
            removeCookie("token");
          } else {
            navigate("/home");
          }
        } else {
          navigate(`/chat`);
        }
      }
    } catch (error) {


      if (axios.isAxiosError(error)) {
        if (error.response) {
          const { status, data } = error.response;

          if (status === 403 && data.message === "Forbidden") {
            navigate("/congrats");
            return;
          } else if (status === 401) {
            toast.error("بيانات تسجيل الدخول غير صحيحة");
          } else {
            toast.error(data.message || "حدث خطأ أثناء تسجيل الدخول");
          }
        }
        else if (error.request) {
          toast.error("فشل الاتصال بالخادم. تحقق من الشبكة.");
        }
        else {
          toast.error("حدث خطأ غير متوقع.");
        }
      } else {
        toast.error("حدث خطأ غير متوقع.");
      }
    } finally {
      setLoading(false);
    }
  }

  let formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: sendData,
  });

  return (
    <>
      <Toaster />
      <div className="flex flex-row min-h-screen w-full">
        <HeroImg />
        <div className="flex flex-col items-end justify-start w-full mt-10 px-24 relative">
          <button onClick={() => navigate("/")}>
            <div className='w-[40px] h-[40px] border absolute top-0 left-0 cursor-pointer ml-6 border-neutral-800 rounded-full flex justify-center items-center hover:bg-primary-100 transition-all duration-150 group'>
              <MdArrowBackIosNew
                size={22}
                color='#4a4a4a'
                fontWeight={200}
                className="text-neutral-900 group-hover:translate-x-[-2px] group-hover:fill-white transition-transform duration-150"
              />
            </div>
          </button>
          <div>
            <div className="w-full flex justify-end">
              <h1 className="text-[32px] leading-[67.58px] font-[500] text-neutral-900"> Otlob Coach مرحباً بكم في </h1>
            </div>
            <div className="w-full flex justify-end">
              <p className="text-[16px] leading-[24px] font-[400] text-neutral-900">هل تريد انشاء حساب جديد؟<span className="underline mr-1"> <a href="/">انشاء حساب</a></span></p>
            </div>
          </div>
          <div className='w-full my-3'>
            <form onSubmit={formik.handleSubmit}>
              <div className='w-full my-5'>
                <label htmlFor="email" className="block mb-2 text-sm font-medium text-neutral-600 text-right">البريد الالكتروني</label>
                <input
                  type='email'
                  id="email"
                  className="text-right border border-gray-300 text-black text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4"
                  required
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.email && formik.touched.email ? (
                  <div className="text-red-100">{formik.errors.email}</div>
                ) : (
                  ""
                )}
              </div>
              <div className='w-full my-5'>
                <label htmlFor="password" className="block mb-2 text-sm font-medium text-neutral-600 text-right">كلمة السر</label>
                <div className="flex text-right border border-gray-300 text-neutral-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500  w-full p-4">
                  <input
                    value={formik.values.password}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    className="bg-none focus:outline-none w-full text-right rtl order-2 text-black"
                    type={viewPassword ? "text" : "password"}
                    name="password"
                  />
                  {viewPassword ? (
                    <Eye className="cursor-pointer order-1" onClick={handleViewPass} />
                  ) : (
                    <EyeOff className="cursor-pointer order-1" onClick={handleViewPass} />
                  )}
                </div>
                {formik.errors.password && formik.touched.password ? (
                  <div className="text-red-100">{formik.errors.password}</div>
                ) : (
                  ""
                )}
              </div>
              <div className="w-full flex justify-end">
                <p className="text-[16px] leading-[24px] font-[400] text-neutral-900">هل نسيت كلمة السر؟<span className="underline mr-1"> <a href="/resetpassword">اعادة تعيين كلمة السر</a></span></p>
              </div>
              <div className='w-full my-5 flex justify-end '>
                {
                  isLoading ?
                    <BeatLoader className="mt-5" color="#072605" /> :
                    <button type="submit" className="bg-white text-primary-500 p-2 w-full mt-5 border  rounded-md border-primary-500 md:w-[158px] hover:bg-primary-500 hover:text-white hover:border-transparent transition-all duration-500" >
                      تسجيل الدخول
                    </button>
                }
              </div>

            </form>
          </div>
        </div >
      </div >
    </>
  );
}